/* eslint-disable react/prop-types */
/* eslint-disable react/state-in-constructor */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  InfiniteScroll, Grid, Form, Select, Badge, Formatter, Tabs,
} from '@cgn/framework-ui-components/v1';
import PropTypes from 'prop-types';
import { Route } from 'react-router';
import Actions from './Actions';
import Enums from '../Shared/Enums';
import WrapperComunicazione from './Comunicazione/WrapperComunicazione';
import { getQueryParams } from '../Shared/Utils';
import { withEventiServer } from '../Shared/EventiServer/EventiServerContext';
import { messaggiServerEnum } from '../Exports/iframeComunication';

const { Row } = Grid;
const { Col } = Grid;

class ListaMessaggi extends Component {
  state = {
    comunicazioni: [],
    page: 1,
    stopLoading: false,
    tutti: true,
    storico: false,
    comunicazioneCorrente: null,
  };

  eventiServerSubscriptions = [];

  getChildContext() {
    return {
      comunicazioni: this.state.comunicazioni,
      segnaComeLetta: (idInvio) => this.segnaComeLetta(idInvio),
      comunicazioneSelezionata: (idComunicazione) => {
        const { comunicazioneCorrente } = this.state;
        if (idComunicazione != comunicazioneCorrente) {
          this.setState({ comunicazioneCorrente: idComunicazione });
        }
      },
    };
  }

  componentDidMount() {
    const { eventiServerContext } = this.props;
    const ufficioSelezionato = getQueryParams(this.props.location.search).ufficio;
    if (ufficioSelezionato) {
      this.props.impostaUfficioSelezionato(ufficioSelezionato);
    }

    this.caricaMessaggi(this.props.match.params.idCanale, true, this.props.match.params.idComunicazione);

    this.eventiServerSubscriptions = [
      eventiServerContext.subscribe(messaggiServerEnum.NuovoMessaggioPubblicato, () => {
        const take = 20;
        const skip = 0;

        Actions.messaggi(this.props.match.params.idCanale, skip, take, !this.state.tutti, undefined, this.state.storico).then((x) => {
          this.setState({
            comunicazioni: x,
            stopLoading: x.length < take,
            page: 1,
          });
        });
      }),
    ];
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (next.match.params.idCanale != this.props.match.params.idCanale) {
      this.setState({
        comunicazioni: [],
        page: 1,
        stopLoading: false,
      }, () => {
        this.caricaMessaggi(next.match.params.idCanale, true);
      });
    }
  }

  componentWillUnmount() {
    this.eventiServerSubscriptions.forEach((unsubscribeFunc) => { unsubscribeFunc(); });
  }

  vaiAComunicazione = (idInvio) => {
    this.props.history.push(`/messaggi/comunicazioni/${this.props.match.params.idCanale}/${idInvio}`);
  };

  segnaComeLetta = (idInvio) => {
    const invio = this.state.comunicazioni.filter((x) => x.IdInvio == idInvio)[0];

    if (!invio.Letto) {
      Actions.segnaComeLette(idInvio).then((res) => {
        invio.Letto = res.Success;
        this.forceUpdate();
        this.context.caricaCanaliTematici(true);
      });
    }
  };

  caricaMessaggi = (idCanale, vaiA, idInvio) => {
    const take = 20;
    const skip = (this.state.page - 1) * take;

    return Actions.messaggi(idCanale, skip, take, !this.state.tutti, undefined, this.state.storico).then((x) => {
      this.setState({
        comunicazioni: this.state.comunicazioni.concat(x),
        stopLoading: x.length < take,
        page: this.state.page + 1,
      }, () => vaiA && this.vaiAComunicazione(idInvio || (x.length > 0 ? x[0].IdInvio : this.props.match.params.idComunicazione)));
    });
  };

  impostaLettura = (indice) => {
    if (this.state.tutti != (indice == 0)) {
      this.setState({
        comunicazioni: [],
        page: 1,
        stopLoading: false,
        tutti: indice == 0,
      }, () => this.caricaMessaggi(this.props.match.params.idCanale, true));
    }
  };

  render() {
    const { comunicazioneCorrente } = this.state;
    const oggi = new Date();

    return (
      <Row>
        <Col xs={12} md={4}>
          <div className="quesiti__col">
            <div className="quesiti__filtroServizi">
              <Form
                onChange={(x) => {
                  this.setState({
                    ...x,
                    comunicazioni: [],
                    page: 1,
                    stopLoading: false,
                  }, () => this.caricaMessaggi(this.props.match.params.idCanale, true));
                }}
                stato={this.state}
              >
                <Select name="storico" title="Filtra messaggi ">
                  <Select.Option value>
                    Messaggi storicizzati
                  </Select.Option>
                  <Select.Option value={false}>
                    Messaggi recenti
                  </Select.Option>
                </Select>
              </Form>
            </div>

            <Tabs initialIndex={0} onSelect={this.impostaLettura}>
              <Tabs.Tab title="Tutti" />
              <Tabs.Tab title="Non letti" />
            </Tabs>

            <ul className="quesiti__listaPratiche lista">
              <InfiniteScroll onLoadMore={() => this.caricaMessaggi(this.props.match.params.idCanale, false)} container="quesiti__listaPratiche" stopLoading={this.state.stopLoading}>
                {this.state.comunicazioni.map((x, i) => {
                  const messaggioDiOggi = oggi.setHours(0, 0, 0, 0) == new Date(x.DataPubblicazione).setHours(0, 0, 0, 0);

                  return (
                    <li
                      key={x.IdInvio}
                      className={comunicazioneCorrente == x.IdInvio ? 'messaggioInLista selezionato' : 'messaggioInLista'}
                      onClick={() => this.vaiAComunicazione(x.IdInvio)}
                    >
                      {!x.Letto && <Badge alarm>&nbsp;&nbsp;</Badge>}
                      <span className="messaggioInLista__titolo">{x.Letto ? <span>{x.Titolo}</span> : <strong>{x.Titolo}</strong>}</span>
                      <span className="messaggioInLista__sottotitolo" dangerouslySetInnerHTML={{ __html: x.Sottotitolo ? x.Sottotitolo.split('\n').join('<br />') : '' }} />
                      <span className="messaggioInLista__testo">
                        {messaggioDiOggi
                          ? <span>Oggi alle <Formatter valore={x.DataPubblicazione} tipo="hour" /></span>
                          : (
                            <span>{Enums.Giorni[new Date(x.DataPubblicazione).getDay()]} &nbsp;
                              <Formatter valore={x.DataPubblicazione} tipo="date" /> alle <Formatter valore={x.DataPubblicazione} tipo="hour" />
                            </span>
                          )}
                      </span>
                    </li>
                  );
                })}
              </InfiniteScroll>
            </ul>
          </div>
        </Col>
        <Col xs={12} md={8}>
          <div className="quesiti__col quesiti__conversazione messaggi__container">
            <Route path={`${this.props.match.path}/:idComunicazione`} component={WrapperComunicazione} />
          </div>
        </Col>
      </Row>
    );
  }
}

ListaMessaggi.childContextTypes = {
  comunicazioni: PropTypes.array,
  segnaComeLetta: PropTypes.func,
  comunicazioneSelezionata: PropTypes.func,
};

ListaMessaggi.contextTypes = {
  router: PropTypes.object,
  caricaCanaliTematici: PropTypes.func,
};

const mapStateToProps = (state) => ({ ufficioSelezionato: state.ufficioSelezionato, profilo: state.profilo });

const mapDispatchToProps = (dispatch) => ({
  impostaUfficioSelezionato: (ufficioSelezionato) => {
    window.modificaUfficioCorrenteMenuHome && window.modificaUfficioCorrenteMenuHome(ufficioSelezionato);
    dispatch({ type: 'IMPOSTA_UFFICIO_SELEZIONATO', ufficioSelezionato });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withEventiServer(ListaMessaggi));
